
const Code= () => (
    <> 
        <span>{`<`}</span> 
        <span className="text-amarillo">{`code`}</span>
        <span className="mr-2">{`>`}</span>
    </>
);

export default Code;
